export default __webpack_public_path__ + "static/media/people-1.c48fc7bc.jpg";